export enum RedirectCode {
  DEFER = 'DEFER',
  LIABILITIES = 'LIABILITIES',
  CREDIT_CARDS = 'CREDIT_CARDS',
  BILLTECH_PAY = 'BILLTECH_PAY',
}
